import { Box, FormControlLabel, Checkbox, Typography } from "@mui/material";
import { WidgetProps } from "@rjsf/utils";
import { renderDescriptionTooltip } from "./common";

// Compact Checkbox Widget - inline display for form rows
export const ShortCheckboxWidget = (props: WidgetProps) => {
  const { id, value, label, onChange, required, disabled, readonly, schema } = props;

  return (
    <Box
      sx={{
        height: "40px", // Match TextField size="small" height
        display: "flex",
        alignItems: "center",
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            id={id}
            checked={!!value}
            onChange={(event) => onChange(event.target.checked)}
            disabled={disabled || readonly}
            color="primary"
            size="small"
          />
        }
        label={
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body2" component="span">
              {label || ""}
              {required && (
                <Typography component="span" color="error.main" sx={{ ml: 0.5 }}>
                  *
                </Typography>
              )}
            </Typography>
            {renderDescriptionTooltip(schema.description)}
          </Box>
        }
        sx={{
          m: 0,
          "& .MuiFormControlLabel-label": {
            fontSize: "0.875rem",
          },
        }}
      />
    </Box>
  );
};
